{
  "dojo": "zurich",
  "label": "Zurich Dojo",
  "notice": "Current regular class schedule.",
  "classes": [
    {
      "day": "monday",
      "start": "12:00",
      "title": "Adults No-Gi",
      "audience": "adults",
      "format": "No-Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "monday",
      "start": "15:45",
      "title": "Kids 1",
      "audience": "kids",
      "format": "No-Gi",
      "level": "Ages 3–5",
      "coach": "Team Tiago"
    },
    {
      "day": "monday",
      "start": "16:30",
      "title": "Kids 2",
      "audience": "kids",
      "format": "No-Gi",
      "level": "Ages 6–8",
      "coach": "Team Tiago"
    },
    {
      "day": "monday",
      "start": "17:30",
      "title": "Kids 3 / Juniors MMA",
      "audience": "kids",
      "format": "No-Gi",
      "level": "Ages 9–13",
      "coach": "Team Tiago"
    },
    {
      "day": "monday",
      "start": "18:30",
      "title": "Adults No-Gi",
      "audience": "adults",
      "format": "No-Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "monday",
      "start": "19:30",
      "title": "MMA / Striking",
      "audience": "mma",
      "format": "MMA",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "tuesday",
      "start": "12:00",
      "title": "Adults BJJ",
      "audience": "adults",
      "format": "Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "tuesday",
      "start": "15:45",
      "title": "Kids 1",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 3–5",
      "coach": "Team Tiago"
    },
    {
      "day": "tuesday",
      "start": "16:30",
      "title": "Kids 2",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 6–8",
      "coach": "Team Tiago"
    },
    {
      "day": "tuesday",
      "start": "17:30",
      "title": "Kids 3 / Juniors",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 9–13",
      "coach": "Team Tiago"
    },
    {
      "day": "tuesday",
      "start": "18:30",
      "title": "Adults No-Gi — Beginners",
      "audience": "adults",
      "format": "No-Gi",
      "level": "Beginners",
      "coach": "Team Tiago"
    },
    {
      "day": "tuesday",
      "start": "19:30",
      "title": "Adults BJJ",
      "audience": "adults",
      "format": "Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "12:00",
      "title": "Adults No-Gi",
      "audience": "adults",
      "format": "No-Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "15:45",
      "title": "Kids 1",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 3–5",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "16:30",
      "title": "Kids 2",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 6–8",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "17:30",
      "title": "Kids 3 / Juniors",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 9–13",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "18:30",
      "title": "Adults No-Gi",
      "audience": "adults",
      "format": "No-Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "wednesday",
      "start": "19:30",
      "title": "MMA / Striking",
      "audience": "mma",
      "format": "MMA",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "thursday",
      "start": "12:00",
      "title": "Adults BJJ",
      "audience": "adults",
      "format": "Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "thursday",
      "start": "15:45",
      "title": "Kids 1",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 3–5",
      "coach": "Team Tiago"
    },
    {
      "day": "thursday",
      "start": "16:30",
      "title": "Kids 2",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 6–8",
      "coach": "Team Tiago"
    },
    {
      "day": "thursday",
      "start": "17:30",
      "title": "Kids 3 / Juniors",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 9–13",
      "coach": "Team Tiago"
    },
    {
      "day": "thursday",
      "start": "18:30",
      "title": "Adults No-Gi",
      "audience": "adults",
      "format": "No-Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "thursday",
      "start": "19:30",
      "title": "Women Only",
      "audience": "women",
      "format": "BJJ",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "10:00",
      "title": "Women Only",
      "audience": "women",
      "format": "BJJ",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "12:00",
      "title": "Adults No-Gi",
      "audience": "adults",
      "format": "No-Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "15:45",
      "title": "Kids 1",
      "audience": "kids",
      "format": "No-Gi",
      "level": "Ages 3–5",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "16:30",
      "title": "Kids 2",
      "audience": "kids",
      "format": "No-Gi",
      "level": "Ages 6–8",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "17:30",
      "title": "Kids 3 / Junior MMA",
      "audience": "kids",
      "format": "No-Gi",
      "level": "Ages 9–13",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "18:30",
      "title": "Adults No-Gi",
      "audience": "adults",
      "format": "No-Gi",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "friday",
      "start": "19:30",
      "title": "MMA / Striking",
      "audience": "mma",
      "format": "MMA",
      "level": "All levels",
      "coach": "Team Tiago"
    },
    {
      "day": "saturday",
      "start": "10:00",
      "title": "Kids 1",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 3–5",
      "coach": "Team Tiago"
    },
    {
      "day": "saturday",
      "start": "10:30",
      "title": "Kids 2",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 6–8",
      "coach": "Team Tiago"
    },
    {
      "day": "saturday",
      "start": "11:30",
      "title": "Kids 3",
      "audience": "kids",
      "format": "Gi",
      "level": "Ages 9–13",
      "coach": "Team Tiago"
    },
    {
      "day": "saturday",
      "start": "12:30",
      "title": "Kids Competition",
      "audience": "kids",
      "format": "Competition",
      "level": "Invitation / advanced",
      "coach": "Team Tiago"
    },
    {
      "day": "saturday",
      "start": "13:45",
      "title": "Juniors MMA",
      "audience": "kids",
      "format": "No-Gi",
      "level": "Ages 9–13",
      "coach": "Team Tiago"
    },
    {
      "day": "sunday",
      "start": "16:00",
      "title": "Open Mat",
      "audience": "open",
      "format": "Open mat",
      "level": "All levels",
      "coach": "Open mat"
    }
  ],
  "temporary_schedule": {
    "start": "2026-07-27",
    "end": "2026-08-14",
    "days": [
      "monday",
      "wednesday",
      "friday"
    ],
    "kids_camp_start": "2026-08-10",
    "kids_camp_end": "2026-08-14",
    "notice": "From 27 July to 14 August, training at the Zurich Dojo takes place on Mondays, Wednesdays and Fridays only. The Kids Camp runs from 10 to 14 August; all regular kids classes are cancelled during this period. Adults may use the remaining days and times for self-organised open mats. Oss! The expanded schedule will be published here on 14 August and takes effect on 17 August.",
    "notice_de": "Vom 27. Juli bis 14. August findet das Training im Zürich Dojo nur montags, mittwochs und freitags statt. Vom 10. bis 14. August findet das Kids Camp statt; in dieser Zeit entfallen alle regulären Kids Classes. Erwachsene können die übrigen Tage und Zeiten für selbstorganisierte Open Mats nutzen. Oss! Der erweiterte Stundenplan wird hier am 14. August veröffentlicht und gilt ab dem 17. August."
  },
  "notice_de": "Aktueller regulärer Stundenplan.",
  "future_schedule": {
    "publish_date": "2026-08-14",
    "effective_date": "2026-08-17",
    "notice": "Current regular class schedule.",
    "notice_de": "Aktueller regulärer Stundenplan.",
    "classes": [
      {
        "day": "monday",
        "start": "06:30",
        "title": "40+ BJJ Fundamentals (Gi)",
        "title_de": "40+ BJJ Fundamentals (Gi)",
        "audience": "adults",
        "format": "Gi",
        "format_de": "Gi",
        "level": "40+",
        "level_de": "40+"
      },
      {
        "day": "monday",
        "start": "12:00",
        "title": "BJJ All Levels (Gi)",
        "title_de": "BJJ All Levels (Gi)",
        "audience": "adults",
        "format": "Gi",
        "format_de": "Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "monday",
        "start": "15:00",
        "title": "Kids BJJ (No-Gi)",
        "title_de": "Kids BJJ (No-Gi)",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Ages 3–4",
        "level_de": "3–4 Jahre"
      },
      {
        "day": "monday",
        "start": "17:00",
        "title": "Kids Competition / Drills",
        "title_de": "Kids Competition / Drills",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Competition team",
        "level_de": "Wettkampfteam"
      },
      {
        "day": "monday",
        "start": "18:00",
        "title": "MMA / Striking",
        "title_de": "MMA / Striking",
        "audience": "mma",
        "format": "MMA / Striking",
        "format_de": "MMA / Striking",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "monday",
        "start": "19:00",
        "title": "BJJ All Levels (No-Gi)",
        "title_de": "BJJ All Levels (No-Gi)",
        "audience": "adults",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "All levels · 90 min",
        "level_de": "Alle Levels · 90 Min."
      },
      {
        "day": "tuesday",
        "start": "12:00",
        "title": "BJJ All Levels (No-Gi)",
        "title_de": "BJJ All Levels (No-Gi)",
        "audience": "adults",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "tuesday",
        "start": "16:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 5–6",
        "level_de": "5–6 Jahre"
      },
      {
        "day": "tuesday",
        "start": "17:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 7–12",
        "level_de": "7–12 Jahre"
      },
      {
        "day": "tuesday",
        "start": "18:00",
        "title": "BJJ Fundamentals (Gi)",
        "title_de": "BJJ Fundamentals (Gi)",
        "audience": "adults",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Fundamentals",
        "level_de": "Fundamentals"
      },
      {
        "day": "tuesday",
        "start": "19:00",
        "title": "BJJ / No-Gi Sparring (No-Gi)",
        "title_de": "BJJ / No-Gi Sparring (No-Gi)",
        "audience": "adults",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Sparring",
        "level_de": "Sparring"
      },
      {
        "day": "wednesday",
        "start": "12:00",
        "title": "BJJ All Levels (No-Gi)",
        "title_de": "BJJ All Levels (No-Gi)",
        "audience": "adults",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "wednesday",
        "start": "16:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 5–6",
        "level_de": "5–6 Jahre"
      },
      {
        "day": "wednesday",
        "start": "17:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 7–12",
        "level_de": "7–12 Jahre"
      },
      {
        "day": "wednesday",
        "start": "18:00",
        "title": "BJJ Fundamentals (Gi)",
        "title_de": "BJJ Fundamentals (Gi)",
        "audience": "adults",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Fundamentals",
        "level_de": "Fundamentals"
      },
      {
        "day": "wednesday",
        "start": "19:00",
        "title": "BJJ Advanced (Gi)",
        "title_de": "BJJ Advanced (Gi)",
        "audience": "adults",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Advanced · 90 min",
        "level_de": "Advanced · 90 Min."
      },
      {
        "day": "thursday",
        "start": "12:00",
        "title": "BJJ All Levels (Gi)",
        "title_de": "BJJ All Levels (Gi)",
        "audience": "adults",
        "format": "Gi",
        "format_de": "Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "thursday",
        "start": "16:00",
        "title": "Kids Competition / Drills",
        "title_de": "Kids Competition / Drills",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Competition team",
        "level_de": "Wettkampfteam"
      },
      {
        "day": "thursday",
        "start": "17:00",
        "title": "Kids Competition / Drills",
        "title_de": "Kids Competition / Drills",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Competition team",
        "level_de": "Wettkampfteam"
      },
      {
        "day": "thursday",
        "start": "18:00",
        "title": "BJJ All Levels (No-Gi)",
        "title_de": "BJJ All Levels (No-Gi)",
        "audience": "adults",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "thursday",
        "start": "19:00",
        "title": "Women Only BJJ (Gi)",
        "title_de": "Women Only BJJ (Gi)",
        "audience": "women",
        "format": "Gi",
        "format_de": "Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "friday",
        "start": "10:00",
        "title": "Women Only BJJ (No-Gi)",
        "title_de": "Women Only BJJ (No-Gi)",
        "audience": "women",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "friday",
        "start": "12:00",
        "title": "BJJ All Levels (No-Gi)",
        "title_de": "BJJ All Levels (No-Gi)",
        "audience": "adults",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "friday",
        "start": "15:00",
        "title": "Kids BJJ (No-Gi)",
        "title_de": "Kids BJJ (No-Gi)",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Ages 3–4",
        "level_de": "3–4 Jahre"
      },
      {
        "day": "friday",
        "start": "16:00",
        "title": "Kids BJJ (No-Gi)",
        "title_de": "Kids BJJ (No-Gi)",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Ages 5–6",
        "level_de": "5–6 Jahre"
      },
      {
        "day": "friday",
        "start": "17:00",
        "title": "Kids BJJ (No-Gi)",
        "title_de": "Kids BJJ (No-Gi)",
        "audience": "kids",
        "format": "No-Gi",
        "format_de": "No-Gi",
        "level": "Ages 7–12",
        "level_de": "7–12 Jahre"
      },
      {
        "day": "friday",
        "start": "18:00",
        "title": "MMA / Striking",
        "title_de": "MMA / Striking",
        "audience": "mma",
        "format": "MMA / Striking",
        "format_de": "MMA / Striking",
        "level": "All levels",
        "level_de": "Alle Levels"
      },
      {
        "day": "friday",
        "start": "19:00",
        "title": "No-Gi BJJ / MMA / Striking Sparring (No-Gi / MMA / Striking)",
        "title_de": "No-Gi BJJ / MMA / Striking Sparring (No-Gi / MMA / Striking)",
        "audience": "adults",
        "format": "No-Gi / MMA / Striking",
        "format_de": "No-Gi / MMA / Striking",
        "level": "Sparring · 90 min",
        "level_de": "Sparring · 90 Min."
      },
      {
        "day": "saturday",
        "start": "10:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 3–6 · 45 min",
        "level_de": "3–6 · 45 Min."
      },
      {
        "day": "saturday",
        "start": "11:00",
        "title": "Kids BJJ (Gi)",
        "title_de": "Kids BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Ages 7–12",
        "level_de": "7–12 Jahre"
      },
      {
        "day": "saturday",
        "start": "12:00",
        "title": "Kids Competition BJJ (Gi)",
        "title_de": "Kids Competition BJJ (Gi)",
        "audience": "kids",
        "format": "Gi",
        "format_de": "Gi",
        "level": "Competition team",
        "level_de": "Wettkampfteam"
      }
    ]
  }
}
